module.exports = __webpack_public_path__ + "static/media/headphone-headset-earphone-svgrepo-com.365901d5.svg";